var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.140625 15.5857C0.140625 23.0432 5.53431 29.2445 12.5885 30.502V19.6682H8.85417V15.502H12.5885V12.1682C12.5885 8.4182 14.9947 6.3357 18.398 6.3357C19.476 6.3357 20.6386 6.50195 21.7166 6.6682V10.502H19.8083C17.9822 10.502 17.5677 11.4182 17.5677 12.5857V15.502H21.551L20.8876 19.6682H17.5677V30.502C24.6219 29.2445 30.0156 23.0445 30.0156 15.5857C30.0156 7.28945 23.2937 0.501953 15.0781 0.501953C6.8625 0.501953 0.140625 7.28945 0.140625 15.5857Z",
    fill: "#593012"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.3d6ff9ff4cae7bbc19476a2d07011a53.svg";
export { ForwardRef as ReactComponent };